module.exports = __webpack_public_path__ + "img/framework.2018f5e3.png";